import Http from '../http'

export default {

  showByCompany(company_id, kind, params) {
    return Http.get(`/companies/${company_id}/dash_counters/${kind}`, {
      params: {...params}
    });
  },

  show(kind) {
    return Http.get(`/dash_counters/${kind}`, {
      params: {...params}
    });
  },
}